















import mobileTypeMixin from '@/plugins/mixins/mobileTypeMixin'
import mixins from 'vue-typed-mixins'

export default mixins(mobileTypeMixin).extend({
    data() {
        return {
            file: null as null | File,
            messageConfirmationUpload: null as null | string
        }
    },
    methods: {
        ajouterFichier() {
            if (!this.file) return

            const formData = new FormData()
            formData.append('file', this.file, this.file.name)
            this.$loader.go()
            this.$http
                .api(`rotationProduit`)
                .post(formData)
                .then(() => {
                    this.$swal.toast.success('Le fichier de rotation a bien été traité.')
                    this.file = null
                    this.messageConfirmationUpload = 'Import réalisé avec succès'
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        }
    }
})
